export enum SeatingType {
  GENERAL = "general",
  RANDOM = "random",
  SELECTED = "selected",
}
